import { useStore } from 'effector-react';
import { $curso } from './curso.store';

export const useCurso = () => {
  const curso = useStore($curso);

  return { curso };
};
